import React, { useState, useEffect } from "react";

interface AddImageComponentProps {
    section: {
        id: number;
        imageFile?: File | null;
        preview?: string; // URL from API
        caption?: string;
        isFullWidth?: boolean;
    };
    onChange: (id: number, updatedData: Partial<any>) => void;
    onClose: () => void;
}

const AddImageComponent: React.FC<AddImageComponentProps> = ({ section, onChange, onClose }) => {
    const [localPreview, setLocalPreview] = useState<string | undefined>(section.preview);

    useEffect(() => {
        // Update preview if section.preview changes (API load)
        if (!section.imageFile) {
            setLocalPreview(section.preview);
        }
    }, [section.preview, section.imageFile]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0] || null;
        onChange(section.id, { imageFile: file });
        if (file) {
            setLocalPreview(URL.createObjectURL(file));
        } else {
            setLocalPreview(section.preview);
        }
    };

    const handleCaptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(section.id, { caption: e.target.value });
    };

    const handleFullWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(section.id, { isFullWidth: e.target.checked });
    };

    return (
        <div style={{ padding: '10px', position: 'relative', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
            <button
                style={{ position: 'absolute', top: 5, right: 5, border: 'none', background: 'none', color: 'black', cursor: 'pointer' }}
                onClick={onClose}
            >
                X
            </button>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                <label>Image (Required)</label>
                <input
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                    required={!section.preview && !section.imageFile}
                />

                {localPreview && (
                    <img
                        src={localPreview}
                        alt="Preview"
                        style={{ width: '70%', objectFit: 'cover', borderRadius: '5px', marginTop: '5px' }}
                    />
                )}

                <input
                    type="text"
                    value={section.caption || ''}
                    onChange={handleCaptionChange}
                    className="form-control"
                    placeholder="Enter caption (optional)"
                />

                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input
                        type="checkbox"
                        checked={section.isFullWidth || false}
                        onChange={handleFullWidthChange}
                    />
                    <span>Full Width (optional)</span>
                </div>
            </div>
        </div>
    );
};

export default AddImageComponent;
